module.exports = __webpack_public_path__ + "img/excavaciones.b6215ba2.png";